<script setup lang="ts">
import { CancerCondition, PersonData } from "@/entities/conditions";
import MedicalFormBuilder from "@/components/medicalConditionForms/MedicalFormBuilder.vue";
import { parseSchema } from "@/components/medicalConditionForms/schema";
import { useMedicalForm } from "../useMedicalForm";

import cancer from "./cancer.json";

export interface Props {
    condition: CancerCondition,
    personDetails: PersonData
}

const props = defineProps<Props>();

const emit = defineEmits<{
        (on:"update:condition", value: CancerCondition): void
    }>();

const { onConditionUpdate, state } = useMedicalForm<CancerCondition>({
    ...props.condition,
    diagnosis_date: props.condition.diagnosis_date || "",
    medications: props.condition.medications || [],
}, emit);
</script>

<template>
    <MedicalFormBuilder
        :schema="parseSchema(cancer)"
        :diagnosis-date="state.condition.diagnosis_date"
        :initial-form="state.condition"
        :person-details="props.personDetails"
        @update:form="onConditionUpdate"
    />
</template>

<style>

</style>
